<template>
  <div class="local-modal__mask">
    <component :is="maskComponent"/>
  </div>
</template>

<script>
import Tether from 'tether'
import { mapState } from 'vuex'
import { path } from 'ramda'

const getStateValue = (prop) => path(['localModal', prop])

export default {
  name: 'LocalModalMask',
  data() {
    return {
      tether: null,
    }
  },
  computed: {
    ...mapState(
      {
        targetElement: getStateValue('targetElement'),
        maskComponent: getStateValue('maskComponent'),
        colour: getStateValue('colour'),
      },
    ),
  },
  mounted() {
    this.tether = new Tether({
      element: this.$el,
      target: this.targetElement,
      attachment: 'top left',
      targetAttachment: 'top left',
    })
  },
  beforeDestroy() {
    if (this.tether) {
      this.tether.destroy()
      this.tether = null
    }
  },
}
</script>
